import { IonModal } from "@ionic/react";
import { FC } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface Props {
  isOpen: boolean;
  onDismiss(): void;
  onAccept(): void;
  onDecline(): void;
  saving?: boolean;
}

const NotificationConsentModal: FC<Props> = ({
  isOpen,
  onDismiss,
  onAccept,
  onDecline,
  saving
}) => {
  const { t } = useTranslation();

  return (
    <IonModal
      cssClass="resonance-modal"
      isOpen={isOpen}
      backdropDismiss={true}
      onWillDismiss={onDismiss}
    >
      <Container onClick={onDismiss}>
        <Card onClick={(e) => e.stopPropagation()}>
          <Title>{t("notifications_title", "Rester informé ?")}</Title>
          <Message>
            {t(
              "notifications_message",
              "Souhaites-tu poursuivre l'étude Mentalo pour 1 an et continuer à recevoir les rappels des 4 prochains questionnaires ?"
            )}
          </Message>

          <Buttons>
            <ModalButton onClick={onDecline} disabled={saving}>
              {t("notifications_decline", "Non, merci")}
            </ModalButton>
            <ModalButton2 onClick={onAccept} disabled={saving}>
              {t("notifications_accept", "Oui, rappelle-moi")}
            </ModalButton2>
          </Buttons>
        </Card>
      </Container>
    </IonModal>
  );
};

const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Card = styled.div`
  width: 90%;
  max-width: 400px;
  background-color: #ffffff;
  border-radius: 25px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.div`
  font-size: 22px;
  text-align: center;
  margin-bottom: 10px;
  color: black;
`;

const Message = styled.div`
  font-size: 18px;
  padding: 10px 10px;
  text-align: left;
  color: black;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
`;

const ModalButton = styled.button`
  background-color: #eee;
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  color: black;
`;

const ModalButton2 = styled.button`
  background-color: #007aff;
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  color: white;
`;

export default NotificationConsentModal;
